/* tslint:disable */
/* eslint-disable */
/**
 * Coworker IAM API
 * Provides coworker identity and access management functionalities
 *
 * The version of the OpenAPI document: 1.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrinterDto } from './PrinterDto';
import {
    PrinterDtoFromJSON,
    PrinterDtoFromJSONTyped,
    PrinterDtoToJSON,
} from './PrinterDto';

/**
 * 
 * @export
 * @interface PrinterPreferencesDto
 */
export interface PrinterPreferencesDto {
    /**
     * List of recently used printers, ordered by most recent
     * @type {Array<PrinterDto>}
     * @memberof PrinterPreferencesDto
     */
    recentlyUsedPrinters?: Array<PrinterDto>;
}

/**
 * Check if a given object implements the PrinterPreferencesDto interface.
 */
export function instanceOfPrinterPreferencesDto(value: object): boolean {
    return true;
}

export function PrinterPreferencesDtoFromJSON(json: any): PrinterPreferencesDto {
    return PrinterPreferencesDtoFromJSONTyped(json, false);
}

export function PrinterPreferencesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrinterPreferencesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'recentlyUsedPrinters': json['recentlyUsedPrinters'] == null ? undefined : ((json['recentlyUsedPrinters'] as Array<any>).map(PrinterDtoFromJSON)),
    };
}

export function PrinterPreferencesDtoToJSON(value?: PrinterPreferencesDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'recentlyUsedPrinters': value['recentlyUsedPrinters'] == null ? undefined : ((value['recentlyUsedPrinters'] as Array<any>).map(PrinterDtoToJSON)),
    };
}

